import configuration from '@/taskpane/common/configuration'
import BaseApi from './base-api'
import OrgSettings from './models/org-settings'
import AttachmentChunk from './models/attachment-chunk'
import AttachmentRequest from './models/attachment-request'
import TrackingInfo from './models/tracking-info'
import RewriteRequest from './models/rewrite-request'
import RewriteResult from './models/rewrite-result'
import AttachmentContents from '../events/models/attachment-contents'
import PendingTrackingItem from './models/pending-tracking-item'
import { AxiosInstance } from 'axios'

class CrmApi extends BaseApi {
  private _service: AxiosInstance | null = null

  get Service(): AxiosInstance {
    if (!this._service) {
      this._service = this.buildService(true)
    }
    return this._service
  }

  async getOrgSettings(userId: string): Promise<OrgSettings> {
    const response = await this.Service.get(configuration.CIRRUS_API_BASEURL + `/api/users/${userId}/settings/general`)
    return response.data.Settings as OrgSettings
  }

  async uploadAttachmentChunk(chunk: AttachmentChunk): Promise<void> {
    return this.Service.post(configuration.CIRRUS_CRM_API_BASEURL + '/v2/activities/upload', JSON.stringify(chunk))
  }

  async getAttachmentContents(atts: AttachmentRequest): Promise<AttachmentContents[]> {
    const response = await this.Service.post(configuration.CIRRUS_CRM_API_BASEURL + '/v2/office/attachments', JSON.stringify(atts))

    return response.data.attachments as AttachmentContents[]
  }

  async sendTrackingInfo(trackingInfo: TrackingInfo) {
    return this.Service.post(configuration.CIRRUS_TRACKING_BASEURL + '/api/HttpTrigger-EmailRaw', JSON.stringify(trackingInfo))
  }

  async rewriteEmail(rewriteRequest: RewriteRequest): Promise<RewriteResult> {
    const result = await this.Service.post(configuration.CIRRUS_REWRITE_BASEURL + '/api/HttpTrigger-EmailRewrite', JSON.stringify(rewriteRequest))
    return result.data
  }

  async getPendingTracking(
    userId: string,
    items: {
      messageId: string
      threadId: string
      threadIndex: string
      headerMessageId: string
      subject: string
      replyTrackingId: string
      emailGuid: string
    }[],
  ): Promise<PendingTrackingItem[]> {
    if (!userId) {
      throw new Error('User ID is not available')
    }
    const response = await this.Service.post(configuration.CIRRUS_API_BASEURL + `/api/users/${userId}/tracking/pending`, JSON.stringify(items))
    return (response.data.items as PendingTrackingItem[]) ?? new Array<PendingTrackingItem>()
  }
}

export default new CrmApi()
